import Image from "next/image";
import IconDesktop from "./last-second-icon-desktop.svg";
import IconMediumMobile from "./last-second-icon-medium-mobile.svg";
import IconMedium from "./last-second-icon-medium.svg";
import IconMobile from "./last-second-icon-mobile.svg";

export const HotelLastSecondIcon: React.FC<{
  size?: "small" | "large" | "medium";
}> = ({ size = "small" }) => {
  if (size === "small") {
    return <Image alt="" width={131} height={60} src={IconMobile.src} />;
  }

  if (size === "medium")
    return (
      <>
        <Image
          width={131}
          className="md:hidden"
          height={60}
          src={IconMediumMobile.src}
          alt=""
        />
        <Image
          width={204}
          className="hidden md:block"
          height={60}
          src={IconMedium.src}
          alt=""
        />
      </>
    );

  return <Image width={150} height={238} src={IconDesktop.src} alt="" />;
};
